import { EventName, EventType } from '@/analytics/types';
import MembershipSelectionEnum from '@/app/enums/MembershipSelectionEnum';
import WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';

import type { MembershipObject } from '../_types/MembershipObject';
import type { WarrantyObject } from '../_types/WarrantyObject';

const BRAND = 'Oura Ring';

export interface BundleAnalyticsProps {
  cart_id: string | null;
  membershipObj: MembershipObject;
  warrantyObj: WarrantyObject;
}

const sendBundleAnalytics = async ({
  cart_id,
  membershipObj,
  warrantyObj,
}: BundleAnalyticsProps) => {
  const bundleModalSkipAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'cart',
      cta: 'skip_this_step',
      location: 'add_on_module',
      path: '/cart',
    });
  };

  const bundleModalAddToCartAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'cart',
      cta: 'add_to_cart',
      location: 'add_on_module',
      path: '/cart',
    });
  };

  const bundleModalMembershipAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventName.ProductAdded, {
      brand: BRAND,
      cart_id,
      category: 'membership',
      coupon: '',
      currency: membershipObj.currency,
      image_url: membershipObj.image_url,
      name: `${membershipObj.membershipSelection}`,
      position: '',
      price: membershipObj.price,
      product_id: membershipObj.product_id,
      quantity: 1,
      sku: membershipObj.sku,
      stockStatus: 'inStock',
      url: membershipObj.url,
      variant: membershipObj.variant,
      variant_name: `one-year`,
    });
  };

  const bundleModalWarrantyAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventName.ProductAdded, {
      brand: BRAND,
      cart_id,
      category: 'extended_warranty',
      coupon: '',
      currency: warrantyObj.currency,
      image_url: warrantyObj.image_url,
      name: `${warrantyObj.warrantySelection}-extended-warranty`,
      position: '',
      price: warrantyObj.price,
      product_id: warrantyObj.product_id,
      quantity: 1,
      sku: warrantyObj.sku,
      stockStatus: 'inStock',
      url: warrantyObj.url,
      variant: warrantyObj.variant,
      variant_name: `${warrantyObj.warrantySelection}`,
    });
  };

  if (
    warrantyObj.warrantySelection === WarrantySelectionEnum.OneYear &&
    membershipObj.membershipSelection === MembershipSelectionEnum.OneMonth
  ) {
    await bundleModalSkipAnalytics();
  } else if (
    warrantyObj.warrantySelection !== WarrantySelectionEnum.OneYear &&
    membershipObj.membershipSelection !== MembershipSelectionEnum.OneMonth
  ) {
    await bundleModalAddToCartAnalytics();
    await bundleModalMembershipAnalytics();
    await bundleModalWarrantyAnalytics();
  } else if (warrantyObj.warrantySelection !== WarrantySelectionEnum.OneYear) {
    await bundleModalAddToCartAnalytics();
    await bundleModalWarrantyAnalytics();
  } else if (
    membershipObj.membershipSelection !== MembershipSelectionEnum.OneMonth
  ) {
    await bundleModalAddToCartAnalytics();
    await bundleModalMembershipAnalytics();
  }
};
export default sendBundleAnalytics;
